var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoTelethon7 = function SvgLogoTelethon7(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "131.2px",
    height: "40px",
    viewBox: "0 0 131.2 40",
    enableBackground: "new 0 0 131.2 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Telethon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    d: "M45.9,20.9h-3.3c-0.3,0-0.6-0.3-0.6-0.6V0.6c0-0.3,0.3-0.6,0.6-0.6h3.3c0.3,0,0.5,0.2,0.5,0.6v19.7 C46.4,20.6,46.2,20.9,45.9,20.9z M73.7,8.3H70v8c0,1,0.5,1.1,1.6,1.1h2.1c0.3,0,0.6,0.2,0.6,0.5V20c0,0.3-0.2,0.5-0.6,0.5 c-0.8,0.1-2.1,0.2-3.3,0.2c-3,0-4.9-1-4.9-4.5V2.7c0-0.3,0.2-0.5,0.6-0.6l3.3-0.6h0.1c0.2,0,0.5,0.3,0.5,0.6V5h3.7 c0.3,0,0.6,0.2,0.6,0.5v2.2C74.2,8,74,8.3,73.7,8.3L73.7,8.3z M89.4,20.9H86c-0.3,0-0.6-0.2-0.6-0.6v-9.5c0-1.5-0.6-2.2-2.3-2.2 c-0.8,0-1.7,0.1-2.2,0.2v11.4c0,0.3-0.2,0.6-0.6,0.6H77c-0.3,0-0.6-0.3-0.6-0.6V0.6c0-0.3,0.2-0.6,0.5-0.6h3.3 c0.3,0,0.6,0.2,0.6,0.6v4.9c0.7-0.2,1.7-0.3,2.8-0.3c4.2,0,6.2,2.1,6.2,5.7v9.5C89.9,20.7,89.6,20.9,89.4,20.9z M99.5,20.8 c-4.4,0-6.8-2.7-6.8-7.1v-1.9c0-4.3,2.4-7.1,6.8-7.1s6.8,2.7,6.8,7.1v1.9C106.3,18.1,103.9,20.8,99.5,20.8z M102,11.9 c0-2.2-0.9-3.3-2.4-3.3c-1.6,0-2.5,1.1-2.5,3.3v1.9c0,2.2,0.9,3.3,2.5,3.3c1.6,0,2.4-1.1,2.4-3.3V11.9z M121.8,20.8h-3.4 c-0.3,0-0.5-0.3-0.5-0.6v-9.6c0-1.2-0.2-2.1-1.6-2.1H115c-1.4,0-1.6,0.9-1.6,2.1v9.5c0,0.3-0.2,0.6-0.6,0.6h-3.3 c-0.3,0-0.5-0.3-0.5-0.6v-9.5c0-3.8,2.1-5.6,6-5.6h1.4c3.9,0,6,1.9,6,5.6v9.5C122.3,20.5,122.1,20.8,121.8,20.8L121.8,20.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.4473,
    y1: 5.6196,
    x2: 62.5717,
    y2: 17.744,
    gradientTransform: "matrix(1 0 0 -1 0 23.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    style: {
      stopColor: "#0067B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    style: {
      stopColor: "#009DDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#38ADE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    style: {
      stopColor: "#B9E0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72CDF4"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M54.2,15.6c-0.7-0.1-1.3-0.4-1.7-0.9c-0.4-0.6-0.5-1.5,0-2.7c0.1-0.2,0.1-0.3,0.2-0.5 c1.6-0.5,3.2-0.9,4.6-1.3c1.5-0.5,2.9-0.9,4.1-1.5c1.3-0.6,2.4-1.3,2.1-2.3c-0.1-0.5-1.1-1.2-2.6-1.4C60,5,58.7,5,57.5,5.3 c-1.6,0.3-3.1,1-4.6,1.8c-2.4,1.5-3.9,3.5-4.6,5.2l-0.7,0.2V13c0.2-0.1,0.3-0.1,0.5-0.1c-0.2,0.6-0.3,1.1-0.3,1.7 c0,1,0.2,1.7,0.7,2.2c0.4,0.4,1,0.6,1.6,0.7c1,0.1,2.4-0.2,3.4-0.5c1.1-0.3,2.1-0.7,3.1-1c1.9-0.6,3.5-1.1,5.1-1.3 c0.1,0,0.2-0.1,0.3-0.1c-1.3,0.1-2.5,0.3-3.9,0.6C56.9,15.4,55.3,15.7,54.2,15.6z M55.3,8.7c0.6-0.5,1.3-0.8,2-1.1 C58,7.3,58.6,7.1,59.2,7c0.9-0.2,1.8-0.1,2.2,0.1c0.5,0.2,0.5,0.5,0.5,0.7c-0.3,1.1-2.5,1.7-4.9,2.5c-1.2,0.3-2.7,0.7-4.2,1.1 C53.4,10.4,54.2,9.4,55.3,8.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -5691.9375,
    y1: -9461.2793,
    x2: -5640.9771,
    y2: -9461.2793,
    gradientTransform: "matrix(-0.3347 0.6874 1.3945 0.679 11380.8154 10333.208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#009DDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    style: {
      stopColor: "#10A8E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    style: {
      stopColor: "#90CBEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    style: {
      stopColor: "#B9E0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    style: {
      stopColor: "#B4DEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    style: {
      stopColor: "#91D5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#7BCFF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    style: {
      stopColor: "#72CDF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A2DE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M87.5,2.1c-6.7,1.5-12.7,4.7-18.1,7.7c-9.8,5.2-17.6,7.7-21.3,5.9c0,0.3,1.7,10.3,20.1,0 c9-5,19.5-11.6,30.4-11.8c7-0.1,14.7,3,21.2,7.1c-3.8-2.9-7.6-5.3-11.6-7C101.1,1.2,93.8,0.7,87.5,2.1L87.5,2.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.3705,
    y1: 26.6625,
    x2: 25.033,
    y2: 4.5558,
    gradientTransform: "matrix(1 0 0 -1 0 23.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009DDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#3DAEE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    style: {
      stopColor: "#9AD0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    style: {
      stopColor: "#B9E0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72CDF4"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M63.5,6.7c0,0-5.2,5.6-15.3,3.5C43.3,9,38.7,6.4,34.4,4.6c-4.5-1.9-8.5-2.2-11.4-1.4 c-3,0.8-4.9,2.2-5.6,3.5C17.2,7,17.1,7.2,17,7.5c1.6-0.8,4-1.5,7.2-1.4c3.3,0.2,7.3,1.5,12,3.7c4.8,2.3,12.6,4.7,18.3,4.1 C58.9,13.3,64,10.7,63.5,6.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    d: "M89.3,20.8H86c-0.3,0-0.6-0.2-0.6-0.6v-9.4c0-1.5-0.6-2.2-2.3-2.2c-0.8,0-1.7,0.1-2.2,0.2v11.4 c0,0.3-0.2,0.6-0.6,0.6H77c-0.3,0-0.6-0.3-0.6-0.6V0.6c0-0.3,0.2-0.6,0.5-0.6h3.3c0.3,0,0.6,0.2,0.6,0.6v4.9 c0.7-0.2,1.7-0.3,2.7-0.3c4.2,0,6.2,2.1,6.2,5.7v9.5C89.9,20.6,89.6,20.8,89.3,20.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.9093,
    y1: -670.5807,
    x2: 2.1159,
    y2: -679.606,
    gradientTransform: "matrix(1 0 0 1 0 682.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009DDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#009FDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    style: {
      stopColor: "#00A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    style: {
      stopColor: "#55B4E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#8DCAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    style: {
      stopColor: "#B9E0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72CDF4"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M15.6,10.7c-3.8,0.9-7.1,0.7-9.6-0.2C3,9.4,1.1,7.8,0.3,6.4C0.1,6.1,0.1,5.8,0,5.6 c1.6,0.9,4,1.9,7.2,2c2.4,0.1,5.2-0.3,8.3-1.3V10.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    d: "M121.8,20.8h-3.3c-0.3,0-0.6-0.3-0.6-0.6v-9.6c0-1.2-0.2-2.1-1.6-2.1H115c-1.4,0-1.6,0.9-1.6,2.1v9.5 c0,0.3-0.2,0.6-0.5,0.6h-3.3c-0.3,0-0.5-0.3-0.5-0.6v-9.5c0-3.8,2.1-5.6,6-5.6h1.4c3.9,0,6,1.9,6,5.6v9.5 C122.3,20.5,122.1,20.8,121.8,20.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED1B2E",
    d: "M61.6,24.8l3.1,5.4h4.5l3.1-5.4L61.6,24.8 M72.8,24.8L64,40h6.4l5.6-9.8L72.8,24.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0081C6",
    d: "M38.6,14.2h-8.7v0.1c0,1.5,0.6,3,2.8,3c1.7,0,4.1-0.1,5.2-0.2h0.1c0.3,0,0.5,0.1,0.5,0.5v2.1 c0,0.5-0.1,0.6-0.6,0.7c-1.7,0.5-3.2,0.6-5.5,0.6c-3.3,0-6.8-1.7-6.8-7V12c0-4.4,2.6-7.1,6.8-7.1c4.5,0,6.7,3,6.7,7.1v1.5 C39.1,13.9,38.9,14.2,38.6,14.2z M34.9,11.4c0-2-0.9-3-2.5-3c-1.5,0-2.5,1-2.5,3v0.1h5V11.4z M23.2,8.3h-3.7v8c0,1,0.5,1.1,1.6,1.1 h2.1c0.3,0,0.6,0.2,0.6,0.5V20c0,0.3-0.2,0.5-0.5,0.6c-0.8,0.1-2.1,0.2-3.3,0.2c-3,0-4.9-1-4.9-4.5V2.7c0-0.3,0.2-0.5,0.6-0.6 l3.3-0.6H19c0.2,0,0.5,0.3,0.5,0.5V5h3.7c0.3,0,0.6,0.2,0.6,0.6v2.2C23.7,8,23.5,8.3,23.2,8.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.8896,
    y1: -123.5165,
    x2: 337.8055,
    y2: -183.605,
    gradientTransform: "matrix(0.9589 -0.2837 -0.2837 -0.9589 -262.5205 -60.2846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#009DDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    style: {
      stopColor: "#009FDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    style: {
      stopColor: "#00A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    style: {
      stopColor: "#55B4E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    style: {
      stopColor: "#8DCAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#B9E0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72CDF4"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M130.8,3.1c-0.5-1-1.1-1.7-1.8-2.2c0.2,3.5-2.1,7.4-6.1,8.3c-3,0.7-5-0.3-6.2-0.6H115 c0.4,0.2,6.8,4.4,11.1,3.4C130.2,11.1,132.2,6.4,130.8,3.1L130.8,3.1z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoTelethon7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-telethon7.7749e993.svg";
export { ForwardRef as ReactComponent };